var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.447,
  height: 18.075,
  viewBox: "0 0 17.447 18.075"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.724.6v16.875",
  "data-name": "Path 221"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.849 9.6 7.875 7.875L16.599 9.6",
  "data-name": "Path 222"
}))));
export default SvgArrowDownIcon;